import { cn } from '@/lib/cn';

interface OperatorWordmarkProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  case?: 'lower' | 'upper';
}

const sizeClasses: Record<NonNullable<OperatorWordmarkProps['size']>, string> = {
  sm: 'text-xl tracking-[0.55em] indent-[0.55em]',
  md: 'text-3xl tracking-[0.65em] indent-[0.65em]',
  lg: 'text-5xl tracking-[0.75em] indent-[0.75em]',
  // xl scales down on narrow viewports so the wordmark fits inside the auth
  // card on phone-sized screens (iPhone 17 ~393px). text-6xl @ 0.75em tracking
  // is wider than the card content area on mobile.
  xl: 'text-3xl tracking-[0.45em] indent-[0.45em] sm:text-5xl sm:tracking-[0.65em] sm:indent-[0.65em] md:text-6xl md:tracking-[0.75em] md:indent-[0.75em]',
};

export function OperatorWordmark({
  className,
  size = 'lg',
  case: textCase = 'lower',
}: OperatorWordmarkProps) {
  const word = textCase === 'upper' ? 'OPERATOR' : 'operator';
  return (
    <h1
      aria-label="operator"
      className={cn(
        'font-wordmark font-extrabold text-foreground select-none',
        'leading-none',
        '[text-shadow:0_4px_8px_rgba(0,0,0,0.28),0_2px_3px_rgba(0,0,0,0.18)]',
        'dark:[text-shadow:0_4px_8px_rgba(0,0,0,0.65),0_2px_3px_rgba(0,0,0,0.45)]',
        sizeClasses[size],
        className,
      )}
    >
      {word}
    </h1>
  );
}
